import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
import { MyMissingTranslationHandler } from './helpers/MyMissingTranslationHandler';

import { SharedModule } from './shared/shared.module';

import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';

import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { HeaderComponent } from './layouts/admin-layout/header/header.component';
import { SidebarComponent } from './layouts/admin-layout/sidebar/sidebar.component';
import { ActivatedRoute } from '@angular/router';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';
import { ErrorComponent } from './features/pages/error/error.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProfileManagementComponent } from './features/auth/profile-management/profile-management.component';
import { ProfileFormComponent } from './features/auth/profile-management/profile-form/profile-form.component';
// import { ServiceWorkerModule } from '@angular/service-worker';
// import { environment } from '../environments/environment';

import { BuildDetailsHttpService } from './helpers/BuildDetails/build-details.http.service';
export function fetchBuildDetails(buildDetailsService: BuildDetailsHttpService) {
  return () => buildDetailsService.fetchBuildDetails();
}

@NgModule({
  declarations: [
    AppComponent,
    BasicLayoutComponent,
    EmptyLayoutComponent,
    AdminLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    ErrorComponent,
    ProfileManagementComponent,
    ProfileFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    NgSelectModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('language') || 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    //   // Register the ServiceWorker as soon as the application is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // { provide: APP_INITIALIZER, useFactory: fetchBuildDetails, deps: [BuildDetailsHttpService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['lang'] && (params['lang'] == 'ar' || 'en')) {
        if (localStorage.getItem('language') !== params['lang']) {
          translate.use(params['lang']);
          localStorage.setItem('language', params['lang']);
          location.reload();
        }
      }
    });
  }
}
